<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Cheque Deposit Listing</h1>
    <app-navpath />
  </div>
  <div class="content-container">
    <app-data-form [dataFields]="form" />
    <div class="mb-2 flex w-fit gap-1">
      <button class="shorter-btn show-btn" (click)="showReceipt()">
        <fa-icon [icon]="faSave" class="mr-1" />Show Receipt
      </button>
      <button
        class="shorter-btn print-btn"
        (click)="print('pdf')"
        [disabled]="showTable == false"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faLink" class="mr-1" />Clear
      </button>
      <button
        class="shorter-btn misc-btn"
        (click)="print('excel')"
        [disabled]="showTable == false"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Export to Excel
      </button>
    </div>
  </div>
  <div class="content-container" *ngIf="showTable">
    <app-data-table
      [tableHeaders]="headers"
      [tableEntries]="entries"
      [pageSize]="20"
    />
  </div>
</section>
